import type {SuggestMode} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {useFormContext} from 'react-hook-form'

export function useSuggest() {
  const i18n = useI18n()
  const {watch} = useFormContext()
  const suggestMode: SuggestMode =
    watch('suggest_mode') || (watch('vertical_name') === 'cargo_intercity' ? 'delivery_intercity' : 'delivery_b2b')
  const addressSuggestPlaceholder =
    suggestMode === 'delivery_b2b'
      ? i18n('cargo.create.address.street_house', 'Улица, дом')
      : i18n('cargo.create.address.city_street_house', 'Город, улица, дом')
  return {suggestMode, addressSuggestPlaceholder}
}
